import {Component, Input} from '@angular/core';
import {filter} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {MatDialog} from '@angular/material/dialog';

import {ConsultationStatusesNamesEnum} from '@consultations/enums/consultation-statuses.enum';
import {
  ModalFindUserComponent
} from '@shared-modules/modals/modal-find-user/modal-find-user.component';
import {Patient} from '@core/interfaces/patient.interface';
import {PatientsInviteComponent} from '../../dashboard/patients-invite/patients-invite.component';


@UntilDestroy()

@Component({
  selector: 'app-empty-result',
  templateUrl: './empty-result.component.html',
  styleUrls: ['./empty-result.component.scss']
})
export class EmptyResultComponent {
  @Input() title = 'По данному запросу ничего не найдено!';
  @Input() type = 'base';
  @Input() withoutImg = false;

  consultationsStatusesNamesEnum = ConsultationStatusesNamesEnum;

  constructor(private dialog: MatDialog) {
  }

  invitePatient(): void {
    const dialogRef = this.dialog.open(ModalFindUserComponent, {
      data: {
        isDialogueModal: false
      },
      autoFocus: false,
      panelClass: ['primary-modal', 'modal-md']
    });

    dialogRef.afterClosed()
      .pipe(
        filter(patient => !!patient),
        untilDestroyed(this)
      )
      .subscribe((patient: Patient) => {
        this.dialog.open(PatientsInviteComponent, {
          data: {
            patientId: patient.id
          },
          panelClass: ['primary-modal', 'modal-sm'],
          autoFocus: false
        });
      });
  }
}
